import React from 'react';
import { DialogActions } from '@mui/material';

const ResponsiveDialogActions = ({ children }: React.PropsWithChildren<{}>) => {
  return <DialogActions>{children}</DialogActions>;
};

export default ResponsiveDialogActions;
